import MarkdownIt from 'markdown-it';
import { sameOriginPath } from './sameOriginPath.ts';

/*
 * `html: false` escapes any markup in the text instead of trusting it, and
 * markdown-it refuses javascript: URLs on its own. Together they make the
 * rendered string safe to insert.
 */
export const markdown = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
});

/*
 * A link out of the app opens its own tab, or following it would cost the
 * reader their place. A link to one of our own pages stays in this tab.
 */
markdown.renderer.rules.link_open = (tokens, index, options, _env, self) => {
  const token = tokens[index];

  if (sameOriginPath(token.attrGet('href')) === null) {
    token.attrSet('target', '_blank');
    token.attrSet('rel', 'noopener noreferrer');
  }

  return self.renderToken(tokens, index, options);
};

/*
 * GFM task lists: markdown-it's core has none, and without this a checklist
 * reads as literal brackets. The checkbox is fixed markup of our own, never
 * source HTML, so `html: false` keeps meaning what it says.
 */
markdown.core.ruler.after('inline', 'task_list', (state) => {
  const tokens = state.tokens;
  for (let index = 2; index < tokens.length; index += 1) {
    const inline = tokens[index];
    if (inline.type !== 'inline' || !inline.children?.length) continue;
    if (tokens[index - 1].type !== 'paragraph_open') continue;
    if (tokens[index - 2].type !== 'list_item_open') continue;
    const first = inline.children[0];
    if (first.type !== 'text') continue;
    const match = /^\[( |x|X)\] /.exec(first.content);
    if (!match) continue;

    const checked = match[1] !== ' ';
    first.content = first.content.slice(match[0].length);
    const box = new state.Token('html_inline', '', 0);
    box.content = `<input type="checkbox" disabled${checked ? ' checked' : ''} aria-hidden="true" /> `;
    inline.children.unshift(box);
    tokens[index - 2].attrJoin('class', 'task-list-item');
    if (checked) tokens[index - 2].attrSet('data-checked', 'true');
  }
});
